import { BookMarked, Bug, Circle, GitBranch, SquareCheckBig, Zap } from 'lucide-react';

import { cn } from '@/lib/utils';

interface TypeLike {
  name?: string;
  icon?: string;
  is_epic?: boolean;
}

/** Map a work-item type to a Jira/Plane-style icon + color. Keys off the type's
 * stored `icon` (if set), else its name, else the `is_epic` flag. */
function metaFor(type: TypeLike) {
  const key = (type.icon || type.name || '').toLowerCase();
  if (key.includes('bug')) return { Icon: Bug, color: 'text-red-500' };
  if (key.includes('epic') || type.is_epic) return { Icon: Zap, color: 'text-purple-500' };
  if (key.includes('sub')) return { Icon: GitBranch, color: 'text-sky-500' };
  if (key.includes('story') || key.includes('feature'))
    return { Icon: BookMarked, color: 'text-green-600' };
  if (key.includes('task')) return { Icon: SquareCheckBig, color: 'text-blue-500' };
  return { Icon: Circle, color: 'text-muted-foreground' };
}

export function WorkItemTypeIcon({
  type,
  className,
}: {
  type: TypeLike | null | undefined;
  className?: string;
}) {
  if (!type) return <Circle className={cn('text-muted-foreground size-4', className)} />;
  const { Icon, color } = metaFor(type);
  return <Icon className={cn('size-4', color, className)} />;
}
